// Frontend/src/lib/featureFlags.ts
//
// Features that exist in the codebase but are not ready to be used yet.
//
// Hidden, not deleted: the polls/voting screens, their API layer, their
// routes and the backend behind them all still build and still pass their
// tests. Flipping one constant back to true is the whole of turning the
// feature on -- there is nothing to rewrite or restore.

/**
 * Polls / voting ("Encuestas").
 *
 * Off until the next milestone. While false:
 *   - the resident bottom-nav tab is not rendered
 *   - /resident/polling redirects to the dashboard, so an old bookmark or a
 *     link someone was sent lands somewhere real instead of on a screen the
 *     product is not standing behind yet
 *   - the HOA admin's Communications "Polling" tab is not rendered, and
 *     ?tab=polling falls back to Announcements for the same reason
 *   - the resident dashboard's poll card is not rendered (it was already
 *     behind a "coming soon" blur, over mock data)
 */
export const VOTING_ENABLED = false;
